import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { Button, IconButton } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../util/auth";
import { createLikeCreation, toggleLikeCreation, useCreationLikes } from "../util/db";

function FavoriteButton(props) {
  const { creationId, idx, hideCount = false, full = false, buttonProps = {} } = props;
  const { user } = useAuth();
  const { data: likes } = useCreationLikes(creationId);
  const navigate = useNavigate();

  if (!creationId) return null;

  const likeCount =
    (likes &&
      likes.filter((like) => like.like_idx === idx && like.state === 1).length) ||
    0;
  const favorite =
    (likes &&
      user &&
      likes.filter((like) => like.user_id === user.id && like.like_idx === idx)[0]) ||
    null;

  const isFavorited = favorite && favorite.state === 1;

  const handleFavorite = async () => {
    if (!user) {
      navigate("/login");
      return;
    }

    if (favorite) {
      toggleLikeCreation(favorite);
    } else {
      createLikeCreation(user.id, creationId, idx);
    }
  };

  if (full) {
    return (
      <Button
        aria-label="favorite"
        variant="outlined"
        color={isFavorited ? "primary" : "inherit"}
        onClick={handleFavorite}
        startIcon={isFavorited ? <FavoriteIcon /> : <FavoriteBorderIcon />}
        {...buttonProps}
      >
        {likeCount > 0 && !hideCount && (
          <span style={{ fontSize: 14, marginRight: 8 }}>{likeCount}</span>
        )}
        {isFavorited ? "Favorited" : "Favorite"}
      </Button>
    );
  }
  return (
    <IconButton
      aria-label="favorite"
      color={isFavorited ? "primary" : "default"}
      onClick={handleFavorite}
      sx={{ borderRadius: "25%", minWidth: 40, height: 40 }}
    >
      {isFavorited ? <FavoriteIcon /> : <FavoriteBorderIcon />}
      {likeCount > 0 && !hideCount && (
        <span style={{ fontSize: 16, marginLeft: 4 }}>{likeCount}</span>
      )}
    </IconButton>
  );
}

export default FavoriteButton;
